<template>
  <main id="content" aria-labelledby="main-title">


    <div class="relative overflow-hidden">
      <div class="pt-8 sm:pt-16">

        <Container>
          <FadeIn class="mx-auto max-w-xl text-center prose">
            <h1 class="text-section-title">Book a demonstration of the Elker platform</h1>
            <p class="text-subtitle">Book directly through our calendar. Alternatively, you can <NuxtLink :to="$localePath('/contact')"><span class="underline">contact us</span></NuxtLink> and we will get back to you within one business day.</p>
          </FadeIn>
        </Container>

      </div>

      <FadeIn
      :delay="200"
      class="my-10 text-center lg:hidden">
        <button
        type="button"
        class="inline-flex items-center transition justify-center whitespace-nowrap rounded-md border border-transparent bg-[#096b72] px-3 py-1.5 text-lg font-semibold text-white hover:bg-[#07484b]" 
        @click="calendlyPopup"
        >
          Open calendar
        </button>
      </FadeIn>

      <div class="relative hidden lg:block">
        <div class="absolute inset-0 flex flex-col">
          <div class="flex-1" />
          <div class="w-full flex-1 bg-faun" />
        </div>
        <div class="px-4 sm:px-8 lg:px-0 pt-8 lg:pt-0 relative" style="z-index: 9">
          <ClientOnly>
            <ElementBookCall />
          </ClientOnly>
        </div>
      </div>
    </div>
    
    <div class="bg-faun hidden lg:block">
      <div class="py-8 sm:py-16">
      </div>
    </div>

    <template v-if="page?.dynamic">
      <template v-for="(section, index) in page?.dynamic">
        <component 
        :is="getSectionComponent(section.collection)" 
        :sectionIndex="index" 
        :content="section.item"
        :sectionTotal="page.dynamic.length"
        />
      </template>
    </template>

  </main>
</template>

<script setup>
const route = useRoute()
const contentSections = useContentSections()
const { getItems } = useDirectusItems()
const fields = useFields()
const userStore = useUserStore()
const { userCountry } = storeToRefs(userStore)

const consentCountries = ['US', 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'GB', 'UK', 'IS', 'LI', 'NO', 'CH']

const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

const { data } = await useAsyncData(
  currentLocale.value+'-page-book-demo',
  () => getItems({
    collection: 'book_demo',
    params: {
      fields
    },
  })
)

const page = data?.value

const seo = computed(() => {
  if (page?.seo) {
    return useSeo(page.seo, route.fullPath)
  }
  return {}
})

useHead(seo)

const getSectionComponent = key => {
  return contentSections[key]
}

const calendlyPopup = () => {
  let calendlyUrl = 'https://calendly.com/initial-scoping-team/scoping-discussion?primary_color=096b72&hide_gdpr_banner=1'
  Calendly.initPopupWidget({
    url: calendlyUrl
  })
  return false
}

</script>